/**
 * Enumerations shared by the database schema, the API and the client.
 *
 * These are the single source of truth: `apps/api/src/db/schema.ts` builds its
 * Postgres enums from these arrays, so adding a value here and forgetting the
 * migration is a type error rather than a runtime surprise.
 */
export const SCREENING_STATUSES = [
    'draft',
    'announced',
    'wildcard',
    'live',
    'done',
    'cancelled',
];
export const RESERVATION_STATES = ['booked', 'cancelled'];
export const SWAP_OFFER_STATES = ['pending', 'accepted', 'declined', 'expired'];
export const MENU_SECTIONS = ['house', 'chefs'];
export const TICKET_BACK_STATES = ['stub', 'written'];
export const PITCH_STATES = ['open', 'scheduled', 'rejected', 'withdrawn'];
export const GUARDS = ['armane', 'versace'];
/**
 * Session lifetimes. The client sends the bribe *choice*; the server decides
 * the TTL. A client can never talk itself into a long session.
 * (DESIGN.md §5, "The bribe")
 */
export const SESSION_TTL_BRIBED_DAYS = 180;
export const SESSION_TTL_UNBRIBED_HOURS = 12;
/** Late-cancel window. A cancel inside this freezes `was_late_cancel = true`. */
export const LATE_CANCEL_WINDOW_HOURS = 24;
/**
 * The hype-meter easter egg: rapidly tapping your own already-lit flame sets
 * the whole card on fire for everyone looking at the board. It changes no
 * count and is written down nowhere (DESIGN.md §7).
 *
 * The rate limit is the server's, and it is deliberately generous relative to
 * the eight taps that trigger one: the client only ever sends the *result* of
 * a gesture, so anything above this is a client that has stopped honouring its
 * own detector.
 */
export const ENGULF_TAPS = 8;
export const ENGULF_WINDOW_MS = 2_000;
/** How long the card burns. Long enough to look at, short enough to forgive. */
export const ENGULF_DURATION_MS = 3_000;
/** Engulf messages accepted per client per second before they are dropped. */
export const ENGULF_RATE = 2;
/** Jump scare limits — server-enforced. */
export const JUMP_SCARE_DAILY_LIMIT = 3;
export const JUMP_SCARE_GLOBAL_COOLDOWN_MS = 60_000;
/** Limits reset at 04:00 local, not midnight — movie nights run late. */
export const JUMP_SCARE_RESET_HOUR = 4;
/** Door lockout: 3 failures → 10 min, doubling on repeat within 24h. */
export const DOOR_MAX_ATTEMPTS = 3;
export const DOOR_LOCKOUT_BASE_MS = 10 * 60_000;
/** Invite codes are read aloud and typed on phones: no 0/O, no 1/l/I. */
export const INVITE_CODE_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
export const INVITE_CODE_LENGTH = 8;
//# sourceMappingURL=enums.js.map